export const STATIC_COLUMNS_COUNT = 3;
const getVisibleDetailColumnsCount = (columns = {}) => Object.keys(columns).filter((columnKey) => columnKey !== "priority").filter((columnKey) => {
  var _a;
  return (_a = columns[columnKey]) == null ? void 0 : _a.visible;
}).length;
export default getVisibleDetailColumnsCount;
